import classnames from 'classnames';
import React from 'react';

import { SingleNavTabContainerStyled } from './styled';
import { ITabSingleNavProps } from './types';

const SingleTabNav: React.FC<ITabSingleNavProps> = ({ children, active, onClick, compKey, disabled }) => (
  <SingleNavTabContainerStyled
    className={classnames('gx-m-0 custom-tabs-tab-nav', {
      'custom-tabs-active': active,
      'custom-tabs-disabled': disabled,
    })}
    onClick={() => {
      if (onClick && !disabled) {
        onClick(compKey);
      }
    }}>
    {children}
  </SingleNavTabContainerStyled>
);

export default React.memo(SingleTabNav);
